export const ENGINE_NAMESPACE_UUID = 'b40599dc-618e-4983-8dee-02b0501db16b';

export function engineUuid(buffer: string): string {
  return buffer;
  // return uuidv5(buffer, ENGINE_NAMESPACE_UUID);
}
